﻿import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class UtilService {

    getGrado(categoria: any, sexo:any) : string {
        const nro =  (((categoria.id -1) * 2) + sexo.id);
        const grado: string = nro % 6 === 0?'6 ':(nro % 6).toString() + ' ';
        const nivel: string = nro / 6 <= 1?'P':'S';
        return grado + nivel;  
    }

}
